import * as React from "react";
import "./styles.scss";
import { Button } from "semantic-ui-react";

interface DetailsPageProps {
  onClose: () => void;
  children: React.ReactNode;
}

const DetailsPage: React.FC<DetailsPageProps> = ({ onClose, children }) => {
  return (
    <div className="playerCardDetailsPage">
      <Button content="Back" onClick={onClose} icon="arrow left" className="backButton" />
      {children}
    </div>
  );
};
export default DetailsPage;
